import { request, withQuery, upload } from './client';
import type { ImportCommitBody, ImportPreview, ImportStatusView, ImportVatBody } from '@kassa/shared';

const IMPORT = '/api/products/import';

export const importsApi = {
  importWarehouses: (outletId: string) =>
    request<{ id: string; name: string }[]>('GET', withQuery(`${IMPORT}/warehouses`, { outletId })),
  importPreview: (file: File) => upload<ImportPreview>(`${IMPORT}/preview`, file),
  importVat: (id: string, body: ImportVatBody) =>
    request<ImportPreview>('POST', `${IMPORT}/${encodeURIComponent(id)}/vat`, body),
  importCommit: (id: string, body: ImportCommitBody) =>
    request<ImportStatusView>('POST', `${IMPORT}/${encodeURIComponent(id)}/commit`, body),
  importStatus: (id: string) => request<ImportStatusView>('GET', `${IMPORT}/${encodeURIComponent(id)}`),
  importReverse: (id: string) =>
    request<ImportStatusView>('POST', `${IMPORT}/${encodeURIComponent(id)}/reverse`),
};
